import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { memo } from 'react';
import styled, { css } from 'styled-components';
import { prop, switchProp } from 'styled-tools';
const Shell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  ${switchProp(prop('size', 'middle'), {
    middle: css`
      height: var(--input-height-default);
      min-width: var(--input-height-default);
      width: var(--input-height-default);
    `,
    medium: css`
      height: var(--input-height-default);
      min-width: var(--input-height-default);
      width: var(--input-height-default);
    `,
    small: css`
      height: var(--input-size-sm);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `,
    large: css`
      height: var(--input-height-lg);
      min-width: var(--input-height-lg);
      width: var(--input-height-lg);
    `,
    xsmall: css`
      height: var(--input-size-xs);
      min-width: var(--input-size-sm);
      width: var(--input-size-sm);
    `
})};
`;
export const IconShell = (props)=>{
    const { icon, size = 'middle', className, dataTestId, onClick } = props;
    return /*#__PURE__*/ _jsx(Shell, {
        onClick: onClick,
        size: size,
        className: classNames('icon-shell', className),
        "data-cy": dataTestId,
        children: icon
    });
};
export const IconWrapper = styled.span`
  color: var(--icon-primary);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const MemoedIconShell = /*#__PURE__*/ memo(IconShell);
export const IconWrapperColor = styled.div`
  color: ${(props)=>`var(--${props.color}-60)`};
  background-color: ${(props)=>`var(--${props.color}-20)`};
  padding: var(--spacing-02);
  width: var(--spacing-07);
  height: var(--spacing-07);
  border-radius: var(--border-radius-base);
  display: flex;
  justify-content: center;
  align-items: center;
`;
